import React from "react";
import { StyledSearchCollaboratorsOption } from "./SearchCollaborators.styled";
import {
  CollaboratorInfo,
  FontWeightEnum,
  IconSizeEnum,
} from "../../types/AppTypes";
import { InputWithOptionsProps } from "../core/InputWithOptions/InputWithOptions";
import { BodyTyp } from "../Typography/Typography";
import { Avatar, AvatarDimensionsEnum } from "../core/Avatar/Avatar";
import { getInitials } from "../../utils/collaborators.utils";
import {
  EMPTY_COLLABORATORS_MESSAGE,
  NAME_SURNAME_LABEL,
} from "../../constants/Dictionary";
import SearchInput from "../core/SearchInput/SearchInput";
import { IconManager } from "../core/IconManager/IconManager";
import { ReactComponent as ArrowRightIcon } from "../../icons/arrowRight.svg";

export interface SearchCollaboratorsProps extends InputWithOptionsProps<number> {
  data: CollaboratorInfo[];
  loading: boolean;
  onChange?: (value: string) => void;
  onSelectCollaborator: (
    collaboratorId: number,
    collaboratorLabel: string,
  ) => void;
  showEmptyMessage?: boolean;
  toggleSearchInput?: () => void;
}

export const SearchCollaborators = ({
  data,
  loading,
  onChange,
  onSelectCollaborator,
  toggleSearchInput,
  showEmptyMessage = false,
  ...props
}: SearchCollaboratorsProps) => {
  const options = data.map((collaborator) => ({
    value: collaborator.id,
    label: (
      <StyledSearchCollaboratorsOption>
        <Avatar
          collaboratorId={collaborator.id}
          initials={getInitials(collaborator.name, collaborator.surname)}
          variant={AvatarDimensionsEnum.BIG}
        />
        <BodyTyp
          variant="2"
          fontWeight={FontWeightEnum.MEDIUM}
        >{`${collaborator.name} ${collaborator.surname}`}</BodyTyp>
      </StyledSearchCollaboratorsOption>
    ),
  }));

  const handleSelect = (id: number) => {
    const collaborator = data.find((c) => c.id === id);
    if (collaborator) {
      onSelectCollaborator(id, `${collaborator.name} ${collaborator.surname}`);
    }
  };

  return (
    <SearchInput
      label={NAME_SURNAME_LABEL}
      options={options}
      loading={loading}
      onSelectOption={handleSelect}
      {...(toggleSearchInput && {
        startIcon: (
          <IconManager size={IconSizeEnum.SMALL} onClick={toggleSearchInput}>
            <ArrowRightIcon />
          </IconManager>
        ),
      })}
      onChange={onChange}
      {...(props.value &&
        showEmptyMessage && {
          optionsEmptyMessage: EMPTY_COLLABORATORS_MESSAGE,
        })}
      {...props}
    />
  );
};
